import React from "react";
import { Link } from "react-router-dom";

const Error: React.FC = () => {
    return (
        <div className="min-h-screen flex flex-col items-center justify-center bg-gray-50 dark:bg-gray-900 px-6 text-center transition-colors">
            <div className="text-8xl mb-6">😵</div>
            <h1 className="text-4xl font-bold text-gray-900 dark:text-white mb-4">Oops!</h1>
            <p className="text-xl text-gray-500 dark:text-gray-400 mb-8">
                Something went wrong. The page you're looking for doesn't exist.
            </p>
            <Link
                to="/"
                className="bg-orange-500 hover:bg-orange-600 text-white font-semibold py-3 px-8 rounded-full transition-colors"
            >
                Go Back Home
            </Link>
        </div>
    );
};

export default Error;
